<div class="cardapio-header">
  <!-- Banner -->
  <div class="banner-container">
    <img *ngIf="bannerUrl" [src]="bannerUrl" class="banner-image" alt="Banner" />
    <div *ngIf="!bannerUrl" class="banner-placeholder">
      <i class="pi pi-image"></i>
    </div>
    <button pButton
            type="button"
            icon="pi pi-camera"
            class="p-button-rounded p-button-text banner-camera-btn"
            [pTooltip]="texts.trocar_banner"
            tooltipPosition="left"
            (click)="trocarBanner.emit()">
    </button>
  </div>

  <!-- Info do Negocio -->
  <div class="negocio-info">
    <div class="logo-container">
      <img *ngIf="logoUrl" [src]="logoUrl" class="logo-image" alt="Logo" />
      <div *ngIf="!logoUrl" class="logo-placeholder">
        <i class="pi pi-shop"></i>
      </div>
    </div>
    <div class="negocio-details">
      <h2 class="negocio-nome">{{ nomeNegocio }}</h2>
    </div>
    <div class="negocio-actions">
      <button pButton
              type="button"
              icon="pi pi-heart"
              class="p-button-rounded p-button-text"
              [pTooltip]="texts.favoritar">
      </button>
      <button pButton
              type="button"
              icon="pi pi-share-alt"
              class="p-button-rounded p-button-text"
              [pTooltip]="texts.compartilhar">
      </button>
    </div>
  </div>

  <!-- Barra de Busca -->
  <div class="busca-container">
    <span class="p-input-icon-left w-full">
      <i class="pi pi-search"></i>
      <input type="text"
             pInputText
             [placeholder]="texts.buscar_produtos"
             (input)="onSearchInput($event)"
             class="w-full busca-input" />
    </span>
  </div>
</div>
